<template>
  <div class="wizard-container">
    <base-dialog
      width="95%"
      height="95%"
      label="Slide was updated. Choose version."
      :is-visible="isInCompareMode"
    >
      <template v-slot:form>
        <div v-if="ready && current" class="content layout column fill-height align-start">
          <div class="tinder layout align-start">
            <div class="card pa-4">
              <v-img
                v-ripple="!currentType === 'master'"
                :style="currentType === 'master' && 'border: 4px solid var(--lightish-blue);'"
                :src="current[0].asset.public.png"
                class="preview"
                @click.stop="
                  $store.commit('localization/selectOne', { tuple: compareTuple, value: 'master' })
                "
              >
                <in-image-todo-picker
                  v-if="currentType === 'master'"
                  :enabled="!tasks.needText"
                  :initial-todos="todos"
                  :image="current[0].asset.public.png"
                  @todo="onTodo"
                />
              </v-img>
              <div :style="currentType === 'master' && 'color: var(--lightish-blue)'">
                Use Master Version
              </div>
            </div>
            <v-spacer />
            <v-divider vertical />
            <v-spacer />
            <div class="card pa-4">
              <v-img
                v-if="current[1]"
                v-ripple="!currentType === 'slave'"
                :style="currentType === 'slave' && 'border: 4px solid var(--lightish-blue);'"
                :src="current[1].asset.public.png"
                class="preview"
                @click.stop="$store.commit('localization/selectOne', { tuple: compareTuple, value: 'slave' })"
              >
                <in-image-todo-picker
                  v-if="currentType === 'slave'"
                  :enabled="!tasks.needText"
                  :initial-todos="todos"
                  :image="current[1].asset.public.png"
                  @todo="onTodo"
                />
              </v-img>
              <div class="text-end actions">
                <div :style="currentType === 'slave' && 'color: var(--lightish-blue)'">
                  Use Local Version
                </div>
              </div>
            </div>
          </div>
          <div class="actions mt-1 align-center justify-center layout">
            <v-fade-transition group>
              <div v-if="!currentType" key="1" class="info-text">
                To continue localisation, select the slide version you want to use in your library.
              </div>
              <div v-else-if="currentType && !tasks.taskMode && todos.length === 0" key="1" class="info-text">
                To create a task, double click on the area you want it to be.
              </div>
              <div v-else-if="tasks.taskMode" key="3" class="layout align-center justify-center">
                <div v-if="tasks.needText" key="4">
                  Create Task here:
                  <simple-task-creation-component
                    :initial-task="tasks.currentTodo"
                    @task-create="taskCreate"
                  />
                </div>
                <div v-else key="5" class="info-text">
                  To create a task, double click on the area you want it to be.
                </div>
                <div v-if="todos.length > 0" key="6" class="ml-4">
                  <todo-pager-view :tasks="todos" />
                </div>
              </div>
            </v-fade-transition>
          </div>
          <div class="actions align-center layout">
            <core-button
              v-show="currentItemIndex > 0"
              not-rounded
              label="Previous"
              flat
              @click.stop="$store.commit('localization/comparisonPrevious')"
            />

            <v-spacer />
            <core-button
              v-show="numberSlides > currentItemIndex + 1"
              :disabled="!currentType"
              not-rounded
              label="Next"
              flat
              @click.stop="$store.commit('localization/comparisonNext')"
            />
            <core-button
              v-show="numberSlides === currentItemIndex + 1"
              :disabled="!currentType"
              :is-loading="isLoading"
              not-rounded
              label="Finish Group"
              flat
              @click.stop="finishProcess"
            />
          </div>
        </div>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '../core/views/dialogs/BaseDialog';
import { mapGetters, mapState } from 'vuex';
import CoreButton from '../core/buttons/CoreButton';
import InImageTodoPicker from '../todos/in-image-todo-picker';
import SimpleTaskCreationComponent from '../todos/SimpleTaskCreationComponent';
import TodoPagerView from '../todos/TodoPagerView';
import { EventBus } from '../../event-bus';
export default {
  name: 'LocalizationWizardCompare',
  components: { TodoPagerView, SimpleTaskCreationComponent, InImageTodoPicker, CoreButton, BaseDialog },
  data() {
    return {
      isLoading: false,
      tasks: {
        taskMode: false,
        needText: false,
        tasks: [],
        currentTodo: {}
      }
    };
  },
  computed: {
    compareTuple() {
      return this['localization/currentComparison'];
    },
    ...mapGetters(['localization/currentComparison', 'localization/getSelectedType']),
    ...mapState('localization', {
      isInCompareMode: ({ comparisons }) => comparisons.on,
      ready: ({ comparisons }) => comparisons.ready,
      current: ({ comparisons }) => comparisons.data.group.current,
      currentType: ({ comparisons }) => comparisons.data.selection.currentType,
      numberSlides: ({ comparisons }) => comparisons.data.group.meta.itemsInGroup,
      currentItemIndex: ({ comparisons }) => comparisons.data.group.meta.currentItem,
      selections: ({ comparisons }) => comparisons.data.selection.selections,
      todos: ({ comparisons }) => comparisons.data.selection.tasks.current
    })
  },
  methods: {
    onTodo(todo) {
      this.tasks.taskMode = true;
      this.tasks.tasks.push(todo);
      this.tasks.currentTodo = todo;
      this.tasks.needText = true;
    },
    taskCreate(task) {
      this.$store.commit('localization/addTask', { data: task.data, geometry: task.geometry });
      this.tasks.needText = false;
    },
    finishProcess() {
      this.isLoading = true;
      this.$store
        .dispatch('localization/finishComparison')
        .then(result => {
          this.$store.dispatch('alerts/success', 'Updated Slide/s.');
          this.$store.dispatch('getAllForAsset');
          this.$store.commit('localization/endCompareMode');
          EventBus.$emit('end-compare-mode', true);
        })
        .catch(x => {
          this.$store.dispatch('alerts/warning', 'Not able to update slide/s.');
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style scoped>
.content {
  position: absolute;
  width: 100%;
  height: 100%;
}
.tinder {
  position: relative;
  width: 100%;
}
.preview {
  cursor: pointer;
}
.card {
  max-width: 45%;
  width: 100%;
  height: 100%;
}
.actions {
  width: 100%;
  user-select: none;
}
.actions .info-text {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.54);
}
</style>
